// src/services/api/nflApi.js
import { rootApi } from './rootApi';

export const nflApi = rootApi.injectEndpoints({
    endpoints: (build) => ({
        getNflUpcomingGames: build.query({
            query: () => '/nfl/week/games?week=current',
            keepUnusedDataFor: 300, // 5 minutes cache
            providesTags: () => [{ type: 'UpcomingGames', id: 'NFL' }],
        }),
        getNflGameScores: build.query({
            query: ({ homeTeamId, awayTeamId }) => 
                `/gateway/nfl-gamescores?home=${homeTeamId}&away=${awayTeamId}`,
            keepUnusedDataFor: 300, // 5 minutes cache
            providesTags: (result, error, { homeTeamId, awayTeamId }) => [
                { type: 'GameScores', id: `NFL-${homeTeamId}-${awayTeamId}` }
            ],
        })
    }),
    overrideExisting: false,
});

export const { 
    useGetNflUpcomingGamesQuery,
    useGetNflGameScoresQuery,
} = nflApi;